import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
export var getMaxNumber = function getMaxNumber(numbers) {
  return numbers.length ? numbers.reduce(function (num1, num2) {
    return Math.max(num1, num2);
  }) : null;
};